module.exports = __webpack_public_path__ + "static/media/gokaldasExports.e4653ec4.svg";